// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer___28d93","FooterInside":"Footer__FooterInside___2mEu5","FooterRight":"Footer__FooterRight___gmAjf","FooterRightLinks":"Footer__FooterRightLinks___gt4kg","CopyRight":"Footer__CopyRight___1J1EN","FooterLeft":"Footer__FooterLeft___1Egw8","PostCode":"Footer__PostCode___3szQk","Socials":"Footer__Socials___2Tt3H"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Footer/Footer.less
// module id = 1144
// module chunks = 0 1